(function poll(){
  var badges = document.querySelectorAll('.jm-transparency-badge-list');
  badges.forEach(function(b){
    if(b.dataset.pv4) return;
    if(b.textContent.trim() === 'Verified Amazon Purchase'){ b.dataset.pv4='1'; return; }
    var txt = b.textContent.trim();
    if(txt !== 'Review collected from another provider' && txt !== '✓ Amazon Purchase') return;
    
    // Reset old patches
    delete b.dataset.p;
    b.removeAttribute('style');
    b.textContent = 'Verified Amazon Purchase';
    
    // 1:1 replicate Judge.me Verified badge style
    b.style.cssText = 'border:1px solid #000;border-radius:24px;padding:3px 9px;font-size:12px;font-weight:500;color:#000;background:transparent;font-family:Inter,sans-serif;line-height:normal;display:inline-flex;align-items:center;white-space:nowrap;flex-shrink:0';
    
    // Move next to name
    var nameEl = b.parentElement && b.parentElement.querySelector('.jm-reviewer-info__name');
    if(nameEl){ var np = nameEl.parentElement; if(np) np.appendChild(b); }
    
    b.dataset.pv4 = '1';
  });
  setTimeout(poll, 500);
})();